// extracted by css-extract-rspack-plugin
export default {"shimmer":"_f17a75cd","shimmerLoadingBackground":"_d2bdc845"};